import { IconProps } from "../../types/genereal";
import { IconWrapper } from "components/ui/IconWrapper";

export const ClockOutlineIcon = ({
  width = "18",
  height = "18",
  color = "#797979",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_56905_481582)">
          <path
            d="M9 1.5C10.4551 1.49973 11.8789 1.92276 13.0978 2.71752C14.3166 3.51227 15.278 4.64444 15.8647 5.97603C16.4514 7.30761 16.6381 8.78111 16.402 10.2169C16.1659 11.6528 15.5172 12.9889 14.535 14.0625"
            stroke={color}
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 4.5V9L12 10.5"
            stroke={color}
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1.875 6.65625C1.63601 7.38274 1.50955 8.14152 1.5 8.90625"
            stroke={color}
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.12207 12C2.5432 12.9689 3.16426 13.8378 3.94457 14.55"
            stroke={color}
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.47656 3.92644C3.68584 3.69861 3.90902 3.48395 4.14481 3.28369"
            stroke={color}
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.4834 16.0648C8.35367 16.7311 10.4118 16.6286 12.2066 15.7798"
            stroke={color}
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_56905_481582">
            <rect width="18" height="18" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
};
